import React, { Component } from 'react';
import { connect } from 'react-redux';
import TranslatedCopy from '../../intl/translated-copy';

import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';

const mapStateToProps = state => ({
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
});
class ErrorPage extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { dispatch, apiError, errorUI } = this.props;
    const code = apiError && apiError.errorData && apiError.errorData.code ? apiError.errorData.code : null;

    if (code?.includes('ERR.')) {
      dispatch(sendAnalytics({
        eventCreator: manageTracking.errorTracking(apiError),
      }));
    }

    if ((apiError && code === null) || errorUI) {
      let errorInfo = apiError;
      if (errorUI) {
        errorInfo = {
          actionType: 'UI-Error',
          errorData: {
            code: 'UI-Error',
            actionable: 'ABORT',
            msg: errorUI.message,
            extraInfo: {
              'debugging_stuff_here': errorUI.stack,
            },
          },
        };
      }

      dispatch(sendAnalytics({
        eventCreator: manageTracking.errorTracking(errorInfo),
      }));
    }
  }

  render() {
    return (
      <div className='ErrorPage'>
        <div className='ErrorPage-content'>
          <div>
            { this.renderError() }
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    const { errorTitle } = this.props;
    return (
      <div>
        <header className='ErrorPage-header'>
          <div className='ErrorPage-img'>
            <img
              alt={ 'Aeromexico error Image' }
              src={ 'https://www.aeromexico.com/cms/sites/default/files/error-plane.png' } />
          </div>
          <h1 className='ErrorPage-title'>
            <TranslatedCopy copyID = { errorTitle } />
          </h1>
        </header>
        <div className='ErrorPage-body'>
          {this.renderErrorMessage() }
        </div>
      </div>
    );
  }

  renderErrorMessage() {
    const {
      errorMessage,
      isActiveFlowCorporate,
    } = this.props;

    const message = errorMessage ? <p className='u-textLarge'>{ errorMessage }</p> : isActiveFlowCorporate ? <TranslatedCopy copyID='MYB_CORP_ERROR' /> : <TranslatedCopy copyID='APP_DEFAULT_ERROR' />;

    return (
      <div className='ErrorPage-description'>
        { message }
      </div>
    );
  }
}

ErrorPage = connect(mapStateToProps)(ErrorPage);

export default ErrorPage;
